export const detectTrainerIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete trainer" || cleaned === "remove trainer") {
        return { intent: "delete_trainer" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) trainer/);
    if (deleteMatch) {
        return { intent: "delete_trainer", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create trainer") || cleaned.includes("add trainer")) {
        return { intent: "create_trainer" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create trainer named (.+)/);
    if (createMatch) {
        return { intent: "create_trainer", name: createMatch[1].trim() };
    }

    return null;
};
